// extracted by mini-css-extract-plugin
module.exports =  {"card":"e462cbfa4b--card--vAb2o","form":"e462cbfa4b--form--DRkY3","question":"e462cbfa4b--question--hXaos","image":"e462cbfa4b--image--tsLKg"};